import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=baf9b27e&"
import script from "./CustomModal.vue?vue&type=script&lang=ts&"
export * from "./CustomModal.vue?vue&type=script&lang=ts&"
import style0 from "./CustomModal.vue?vue&type=style&index=0&id=baf9b27e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports